import { render, staticRenderFns } from "./examGroup.vue?vue&type=template&id=e924a346&scoped=true&"
import script from "./examGroup.vue?vue&type=script&lang=js&"
export * from "./examGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e924a346",
  null
  
)

export default component.exports